export default {
      id: "lang-ru-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#lang-ru",
      toString: function () {
        return this.url;
      }
    }